import dynamicfunction from '../../utils/dynamicfunction';
import { cn } from '../../utils/utils';

const RowView = ({ children, className, style, onClick, isResponsive = false, screenSize = 'md' }) => {
  const { isArabic } = dynamicfunction();

  const responsiveDirectionMap = {
    sm: isArabic ? 'flex-col sm:flex-row-reverse' : 'flex-col sm:flex-row',
    md: isArabic ? 'flex-col md:flex-row-reverse' : 'flex-col md:flex-row',
    lg: isArabic ? 'flex-col lg:flex-row-reverse' : 'flex-col lg:flex-row',
    xl: isArabic ? 'flex-col xl:flex-row-reverse' : 'flex-col xl:flex-row',
  };

  const baseDirection = isArabic ? 'flex-row-reverse' : 'flex-row';
  const responsiveDirection = responsiveDirectionMap[screenSize];

  return (
    <div
      className={cn('flex', isResponsive ? responsiveDirection : baseDirection, className)}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default RowView;
